import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { Modal, Select, Input, Button, Icon, Alert } from 'antd'
import { insuranceCrawler } from '@services/api'
import * as styles from './styles.scss'

@inject((store: any) => {
    const { popupStore, companiesStore, commonSettingsStore } = store

    return { popupStore, companiesStore, commonSettingsStore }
})
@observer
export default class LoginCompanyPopup extends Component<any, any> {
    state: any = {
        prevClientCases: null,
        clientCompanies: {},
        selectedCompany: null,
        validationCode: null,
        userInfo: {},
        errors: {},
        alerts: {},
        loading: false
    }

    errorCodes = {
        default: 'קרתה שגיאה בשרת, פנה לפיתוח',
        500: 'קרתה שגיאה בשרת, פנה לפיתוח',
        423: 'הכניסה לטלפון זה נחסמה על ידי חברת הביטוח, נסה מאוחר יותר',
        401: 'הפרטים שנשלחו שגויים או פג תוקפם'
    }

    successMsgs = {
        smsSuccess: 'ההודעה נשלחה בהצלחה ללקוח, ניתן לאמת את הקוד שהתקבל בהודעה',
        validateSuccess: 'הקוד אומת בהצלחה, המתן כדקה ורענן את התיק הביטוחי של הלקוח'
    }

    componentDidUpdate() {
        const { prevClientCases } = this.state
        const { clientCases } = this.props.popupStore.info
        if (clientCases && JSON.stringify(clientCases) !== prevClientCases) {
            const clientCompanies = {}
            clientCases.map(clientCase => {
                if (!clientCompanies[clientCase.company_id]) {
                    clientCompanies[clientCase.company_id] = 1
                } else {
                    clientCompanies[clientCase.company_id] += 1
                }
            })
            this.setState({ prevClientCases: JSON.stringify(clientCases), clientCompanies })
        }
    }

    handleValidationCode = validationCode => this.setState({ validationCode })

    handleSendSms = () => {
        const { selectedCompany: company_id } = this.state
        const { phone, id: user_id, identity } = this.props.popupStore.info
        this.setState({ loading: true, alerts: {}, validationCode: null })
        insuranceCrawler
            .initSendCode({ phone: `0${phone}`, user_id, company_id, identity })
            .then(res => {
                this.setState({ loading: false, alerts: { success: this.successMsgs.smsSuccess } })
            })
            .catch(({ response: { status } }) => {
                const alerts = {
                    error: status && status in this.errorCodes ? this.errorCodes[status] : this.errorCodes.default
                }
                this.setState({ loading: false, alerts })
            })
    }

    submitValidationCode = () => {
        const { validationCode: code, selectedCompany: company_id } = this.state
        const { id: user_id, identity } = this.props.popupStore.info
        this.setState({ loading: true, alerts: {} })
        insuranceCrawler
            .authUser({ code, user_id, company_id, identity })
            .then(res => {
                this.setState({
                    loading: false,
                    validationCode: null,
                    alerts: { success: this.successMsgs.validateSuccess }
                })
            })
            .catch(({ response: { status } }) => {
                const alerts = {
                    error: status && status in this.errorCodes ? this.errorCodes[status] : this.errorCodes.default
                }
                this.setState({ loading: false, alerts })
            })
    }

    handleSelectCompany = selectedCompany => this.setState({ selectedCompany })

    closePopup = () => {
        this.setState({
            prevClientCases: null,
            clientCompanies: {},
            selectedCompany: null,
            smsCode: null,
            userInfo: {},
            errors: {},
            alerts: {}
        })
        this.props.popupStore.togglePopup(false)
    }

    render() {
        const { clientCompanies, selectedCompany, validationCode, loading, alerts } = this.state
        const {
            popupStore: { popupType, info },
            companiesStore,
            commonSettingsStore: {
                list: {CRAWLER_COMPANIES}
            }
        } = this.props
        const companiesSelect = companiesStore.list
            .filter(company => company.type === 'INSURANCE')
            .map((company, index) => {
                const companyTitle = (
                    <span style={{ fontWeight: company.id in clientCompanies ? 'bold' : 'normal' }}>{`${company.name} ${
                        company.id in clientCompanies ? `(נמצאו ${clientCompanies[company.id]} כיסויים)` : ''
                    }`}</span>
                )
                return (
                    <Select.Option
                        disabled={CRAWLER_COMPANIES && !CRAWLER_COMPANIES.includes(company.id)}
                        key={index}
                        value={company.id}
                    >
                        {companyTitle}
                    </Select.Option>
                )
            })
        const codeValidation = selectedCompany ? (
            <div>
                <div>
                    <div>
                        <strong>שליחת SMS עם קוד התחברות לטלפון הלקוח</strong>
                    </div>
                    <Button disabled={loading} type="primary" onClick={this.handleSendSms}>
                        {loading ? <Icon type="loading" /> : <Icon type="mail" />}
                        שלח SMS לטלפון 0{info.phone}
                    </Button>
                </div>
                <div style={{ marginTop: '0.8rem' }}>
                    <strong>אימות הקוד שהגיע בהודעה</strong>
                </div>
                <div style={{ display: 'flex' }}>
                    <Input
                        style={{ width: '100%', marginLeft: '0.2em' }}
                        value={validationCode}
                        onChange={({ target: { value } }) => this.handleValidationCode(value)}
                        placeholder="הזן את הקוד שהגיע ללקוח בSMS"
                        disabled={loading}
                    />
                    <Button
                        disabled={loading || !validationCode}
                        onClick={this.submitValidationCode}
                        style={{ margin: '0' }}
                    >
                        {loading ? <Icon type="loading" /> : <Icon type="check-circle" />}
                        <span>אמת קוד</span>
                    </Button>
                </div>
            </div>
        ) : (
            <strong>* עליך לבחור חברת ביטוח אליה תרצה להתחבר</strong>
        )
        const alertsContent = alerts
            ? Object.keys(alerts).map((alertKey, index) => (
                  <Alert key={index} message={alerts[alertKey]} type={alertKey} />
              ))
            : ''
        return (
            <Modal
                title={`כניסה לחברות ביטוח עבור ${info.first_name} ${info.last_name}`}
                visible={popupType === 'loginCompany'}
                onCancel={this.closePopup}
                style={{ padding: '0' }}
                footer={<Button onClick={this.closePopup}>סגור</Button>}
            >
                <div>
                    <strong>פרטי התחברות לחברת הביטוח</strong>
                </div>
                <div>
                    <strong>ת.ז</strong>: {info.identity} | <strong>טלפון</strong>: 0{info.phone}
                </div>
                <div style={{ marginTop: '1rem' }}>
                    <strong>בחירת חברת ביטוח</strong>
                </div>
                <Select
                    disabled={loading}
                    value={selectedCompany || undefined}
                    onChange={this.handleSelectCompany}
                    style={{ width: '100%', margin: '0 0 1rem' }}
                    placeholder="בחר חברה אליה תרצה להתחבר"
                >
                    {companiesSelect}
                </Select>
                {codeValidation}
                {alertsContent}
            </Modal>
        )
    }
}
